import React, { useRef, useState, useEffect, FormEvent, FC } from 'react'
import { Action } from '@creditas/icons'
import { styled, utilities, css } from '@creditas/stylitas'
import { useTranslation } from 'react-i18next'
import { useQueryParam, StringParam } from 'use-query-params'

const WrapperIconSystemClose = styled.button<{ small: boolean }>`
  ${utilities.reset.button()}
  position: absolute;
  top: ${props => (props.small ? -6 : 3)}px;
  right: 48px;
  cursor: pointer;
`

const Input = styled.input<{ disabled: boolean; small: boolean }>`
  border-radius: 8px;
  border: 1px solid rgb(238, 238, 238);
  color: rgb(85, 102, 102);
  font-family: 'Nunito Sans', Tahoma;
  font-size: 16px;
  font-weight: 300;
  height: ${props => (props.small ? 34 : 54)}px;
  line-height: 24px;
  padding: 16px;
  position: relative;
  width: 470px;

  ${props =>
    props.disabled &&
    `
    background: rgb(248, 248, 248);
    border-radius: 8px;
    border: 1px solid rgb(204, 204, 204);
  `}

  ${props =>
    !props.disabled &&
    `

  &:focus {
    border: 1px solid rgb(238, 238, 238);
    box-shadow: 0px 8px 16px 0px rgba(170, 187, 187, 0.5);
    outline: none;
  }

  &:hover {
    border: 1px solid rgb(51, 119, 187);
    box-shadow: 0px 8px 16px 0px rgba(170, 187, 187, 0.5);
  }`}
`

const WrapperIconActionSearch = styled.div<{ small: boolean }>`
  cursor: pointer;
  position: absolute;
  right: 9px;
  top: ${props => (props.small ? -6 : 3)}px;
`

const GroupSearch = styled.div<{ small: boolean }>`
  ${props =>
    !props.small &&
    css`
      margin-bottom: 16px;
    `}
  position: relative;
  width: 470px;
`

const TIMEOUT_DELAY = 300

const SearchInput: FC<{ disabled?: boolean; small?: boolean }> = ({
  disabled = false,
  small = false,
}) => {
  const { t } = useTranslation(['surprise', 'common'])
  const [search, setSearch] = useQueryParam('search', StringParam)
  const [value, setValue] = useState(search)
  const timeout = useRef<NodeJS.Timeout | undefined>()

  const clearSearchInput = () => {
    setSearch(undefined)
    setValue(undefined)
  }

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (timeout.current) {
      clearInterval(timeout.current || 0)
    }
    setSearch(value)
    setValue(value)
  }

  useEffect(() => {
    if (timeout.current) {
      clearInterval(timeout.current)
    }
    timeout.current = setTimeout(() => {
      setSearch(value)
    }, TIMEOUT_DELAY)
  }, [value, setSearch])

  return (
    <GroupSearch small={small}>
      <form onSubmit={handleSubmit}>
        <Input
          small={small}
          type="text"
          name="search"
          value={value || ''}
          placeholder={t(`table.head.search-placeholder-input`) || ''}
          maxLength={32}
          disabled={disabled}
          onChange={event => setValue(event.target.value)}
        />
        <WrapperIconActionSearch small={small}>
          <Action.Search
            color={disabled ? 'rgb(204, 204, 204)' : 'rgb(51, 119, 187)'}
            onClick={handleSubmit}
            fontSize="large"
          />
        </WrapperIconActionSearch>
      </form>
      {(value?.length || 0) > 0 && (
        <WrapperIconSystemClose onClick={clearSearchInput} small={small}>
          <Action.IconSystemClose fontSize="large" color="rgb(51, 119, 187)" />
        </WrapperIconSystemClose>
      )}
    </GroupSearch>
  )
}

export { SearchInput }
